<ng-container>
  <div class="event-list" id="section">
    @if (hasEvents) {
        <!-- <div class="title-container">
                  <h2>{{ 'event_list.select_event' | translate }}</h2>
              </div> -->
        @if (flux == "spa") {
          <div class="disclaimer">
            <p>{{ "event_list.disclaimer" | translate }}</p>
          </div>
        }

        <ul class="cards">
            @for (el of eventsList;track el.uuid_event){
              <li
                class="card active"
                [ngClass]="{ 'sold-out': el.sold_out }"
                (click)="eventSelected(el)"
              >
                <div class="header-card">
                  <h3 class="card-title">
                    {{
                      el.event_name[userLanguage] ||
                      el.event_name[languages.default]
                    }}
                  </h3>
                  <div class="wrap-card-img">
                    @if (flux !== "spa") {
                      <img
                        class="card-img"
                        [src]="'assets/img/categorie/' + el.event_category_url"
                        [alt]="el.event_category_name"
                        [matTooltip]="el.event_category_name"
                        matTooltipPosition="above"
                      />
                    }
                  </div>
                </div>
                <div class="card-content">
                  <div class="description">
                    <p>
                      {{
                        el.event_short_description[userLanguage] ||
                        el.event_short_description[languages.default]
                      }}
                    </p>
                  </div>
                </div>
                <div class="chips">
                  @if (el.event_location) {
                    <div class="chip">
                      {{ el.event_location }}
                    </div>
                  }
                  @if (el.sold_out) {
                    <div class="chip sold-out">
                      {{ "event_list.sold_out" | translate }}
                    </div>
                  }
                </div>
              </li>
            }
        </ul>
    } @else {
      <div class="title-container">
        <h2>{{ "event_list.no_events_" + flux | translate }}</h2>
      </div>
    }
  </div>
</ng-container>
